module.exports = __webpack_public_path__ + "static/img/carousel_4_ur2nwj_ar_16_9_w_2150.b313aeb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carousel/carousel_4_ur2nwj_ar_16_9_w_2150.jpg
// module id = 3J/H
// module chunks = 0